import React from "react";
import Layout from "../../shared/Layout/Layout";
import img1 from "../../assets/_about/img_1.png";
import img3 from "../../assets/_about/img_3.png";
import logo from "../../assets/logo.png";
import styles from "./About.module.scss";

const About = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.banner}>
            <div className={styles.overlay}></div>
            <h1>
              About <br /> Us
            </h1>
          </div>

          <main className={styles.main}>
            <h1>Who are we?</h1>
            <div className={styles.body}>
              <div className={styles.imgContainer}>
                <img src={img1} alt="holding-hands" className={styles.img1} />
                <div className={styles.card}>
                  <div className={styles.cardContent}>
                    <img src={logo} alt="logo" />
                    <p>
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Dictum et etiam ultricies mi eu iaculis arcu vel. Vel
                      integer molestie bibendum massa vehicula in magna.
                    </p>
                  </div>
                </div>
              </div>

              <div className={styles.content}>
                <h4>How Eternal was born?</h4>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Dictum et etiam ultricies mi eu iaculis arcu vel. Vel integer
                  molestie bibendum massa vehicula in magna tempus cursus. Quam
                  in non nibh curabitur turpis volutpat. Nec ut suscipit
                  habitasse vulputate aliquet lobortis dolor. Vitae nulla
                  faucibus tincidunt amet tellus dictum. Justo ipsum blandit
                  orci pharetra amet, ullamcorper.
                </p>

                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit
                  adipiscing ut vitae, facilisi nunc faucibus non. Purus ut id
                  scelerisque vitae pharetra sem in. Orci pretium amet phasellus
                  arcu. Consequat egestas viverra facilisi sodales in urna
                  vitae. Sapien, sed dui consequat molestie interdum tempor eget
                  mi. Viverra feugiat habitant aliquet purus nunc, at.
                </p>

                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit
                  adipiscing ut vitae, facilisi nunc faucibus non. Purus ut id
                  scelerisque vitae pharetra sem in. Orci pretium amet phasellus
                  arcu. Consequat egestas viverra facilisi sodales in urna
                  vitae. Sapien, sed dui consequat molestie interdum tempor eget
                  mi. Viverra feugiat habitant aliquet purus nunc, at.
                </p>

                <img src={img3} alt="pic" />

                <h4>building faster, <br /> smarter,together.</h4>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nisl
                  in eu non gravida elit id pellentesque porttitor. Urna
                  molestie in eleifend morbi imperdiet in. Placerat ac massa
                  adipiscing scelerisque aliquam gravida felis sociis. Id quis
                  ultrices velit interdum ipsum pellentesque. Faucibus quis
                  suspendisse eget volutpat quam amet amet. Fusce aliquet at
                  viverra egestas.
                </p>
              </div>
            </div>
          </main>
        </div>
      </div>
    </Layout>
  );
};

export default About;
